import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import { VouchersService, VOUCHER_SERVICE } from "./services/vouchers-service";
import "./styles/style.css";

createApp(App)
  .use(router)
  .provide(VOUCHER_SERVICE, new VouchersService())
  .mount("#app");
